/*
 *  Document   : consultant-activities.js
 *  Author     : Exapoint
 *
 */

// Import required modules

export default class ConsultantActivities {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantActivities"] = this;
        this.init();
    }

    init() {
        $('.js-dataTable-full-pagination').DataTable({
            ajax: jsVars.datatablesAjax,
            order: [[4, "desc"]],
            responsive: true,
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: 'user_full_name',
                    render: function (data, type, row) {
                        if (row.userable_type === "App\\Candidate") {
                            return `<button type="button" data-target="#consultant-activities-edit-user-modal"
                        data-remote="${jsVars.editCandidateUrl.replace(':candidate-id', row.causer_id)}" data-toggle="modal" class="btn btn-ghost text-primary table" >${data}</button>`;
                        } else if (row.userable_type === "App\\Client") {
                            return `<button type="button" data-target="#consultant-activities-edit-user-modal"
                        data-remote="${jsVars.editClientUrl.replace(':client-id', row.causer_id)}" data-toggle="modal" class="btn btn-ghost text-primary table" >${data}</button>`;
                        } else {
                            return data;
                        }
                    }
                },
                {data: "description"},
                {data: "subject_type"},
                {
                    data: 'properties',
                    render: function (data, type, row) {
                        return row.properties.type ? row.properties.type : row.description;
                    }
                },
                {
                    data: 'created_at',
                    render: function (data, type, row) {
                        return new Date(data).toLocaleString('de-CH');
                    }
                }
            ],
            columnDefs: [],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });

        let $editUserModal = $('#consultant-activities-edit-user-modal');
        $editUserModal.on('show.bs.modal', function (e) {
            let $modal = $(e.target);
            let $target = $(e.relatedTarget).first();
            let iframeId = '_' + Math.random().toString(36).substr(2, 9);

            $modal.find('.modal-content').html(`<iframe src="${$target.data('remote')}?minimal_layout=true" onload="adaptIframe()" id="${iframeId}"></iframe>`);
            let $iframe = $('#' + iframeId);
            $iframe.hide();

            window.adaptIframe = function () {
                if(window.frames.length){
                    window.frames[window.frames.length-1].onerror = window.onerror;
                }

                $iframe.contents().find("head")
                    .append($(`
                    <style type='text/css'>
                        #main-container { margin-bottom: 12px; }
                        #page-container.page-header-fixed #main-container {
                            padding-top: 0;
                        }
                        #sidebar, #page-header, #page-footer, .sidebar, .main-header {
                            display:none !important;
                        }
                        #page-container.sidebar-o {
                            padding-left: 0;
                        }
                        .main-container {
                            left: 0px !important;
                            top: 0px !important;
                            padding: 0 60px !important;
                            margin-left: 0px !important;
                            margin-top: 0px !important;
                            margin-bottom: 26px;
                            max-width: 99% !important;
                        }
                        .layout-container.view {
                            max-width: 100% !important
                        }
                        @media(max-width:992px) {
                            .main-container {
                                padding: 0 !important;
                            }
                        }
                     </style>`));
                $iframe.show();
                $iframe.height('67.5vh');
                $iframe.css('border', 0);

                // Setting it to iframe contents height is too low
                // $iframe.height($iframe.contents().height());
            };
        });

        // Every time modal hides
        $editUserModal.on('hide.bs.modal', function (e) {
        });

        // When button confirm is clicked
        $editUserModal.find('.btn-confirm').on('click', function (e) {
            /*let $modal = $(e.target).closest('.modal');

            let $inputs = $modal.find('[name]');
            $inputs.each(function (i, el) {
                let $el = $(el);
                let $input = $(`[name="${$el.data('originalName')}"]`);

                if ($input.length !== 0) {
                    Helpers.applyInputValue($input, $el);
                }
            });*/
        });

        // When button cancel is clicked
        $editUserModal.find('.btn-delete').on('click', function (e) {
            /*let $modal = $(e.target).closest('.modal');

            let $inputs = $modal.find('[name]');
            $inputs.each(function (i, el) {
                let $el = $(el);
                let $input = $(`[name="${$el.data('originalName')}"]`);

                if ($input.length !== 0) {
                    $input.closest('tr').remove();
                    return false;
                }
            });*/
        });
    }
}
